import { useState } from 'react';
import { useCeoWriteAccess } from '@entities/user';
import {
  useGetCeoDashboardQuery,
  useSyncCeoBankAccountsApiMutation,
} from '@shared/api';
import { Button } from '@shared/ui/Button';
import { Card } from '@shared/ui/Card';
import { DebtDetailModal } from '../DebtDetailModal';
import { AlertsRadarSection } from './AlertsRadarSection';
import { DashboardAccountsSection } from './DashboardAccountsSection';
import { DebtPortfolioCard } from './DebtPortfolioCard';
import { InflowsFunnelSection } from './InflowsFunnelSection';
import { ProjectsHealthSection } from './ProjectsHealthSection';
import { ErrorRow, TwoColGrid } from './styles';
import { YesterdayPaymentsCard } from './YesterdayPaymentsCard';

export function CeoDashboardView() {
  const can_write = useCeoWriteAccess();
  const { data, isLoading, isError, refetch } = useGetCeoDashboardQuery();
  const [syncApi, { isLoading: isSyncing }] = useSyncCeoBankAccountsApiMutation();
  const [selectedDebtId, setSelectedDebtId] = useState<string | null>(null);

  if (isLoading) {
    return <Card>Загрузка консоли Генерального директора…</Card>;
  }

  if (isError || !data) {
    return (
      <Card>
        <ErrorRow>
          <span>Не удалось загрузить консоль Генерального директора.</span>
          <Button $size="sm" $variant="secondary" onClick={() => refetch()}>
            Повторить
          </Button>
        </ErrorRow>
      </Card>
    );
  }

  const {
    accounts,
    accounts_summary: accSum,
    yesterday_payments: yPay,
    debt_summary: debtSum,
    inflows_summary: infSum,
    project_matrix: projects,
    alerts,
  } = data;

  return (
    <>
      <AlertsRadarSection alerts={alerts} />

      <DashboardAccountsSection
        accounts={accounts}
        accSum={accSum}
        can_write={can_write}
        isSyncing={isSyncing}
        onSync={() => syncApi()}
      />

      <TwoColGrid>
        <YesterdayPaymentsCard yPay={yPay} />
        <DebtPortfolioCard debtSum={debtSum} onSelectDebt={setSelectedDebtId} />
      </TwoColGrid>

      <InflowsFunnelSection infSum={infSum} />

      <ProjectsHealthSection projects={projects} />

      {selectedDebtId && (
        <DebtDetailModal
          instrumentId={selectedDebtId}
          onClose={() => setSelectedDebtId(null)}
        />
      )}
    </>
  );
}
